function openForm(){
  var button = document.querySelector('.custom-button-form');
  var form = document.querySelector('.hulkForm');
  var side = document.querySelector('.card');
  var headerSection = document.querySelector('[data-section-id="header"]');
  var description = document.querySelector('.product-block-list__item--description');
  var body = document.body;

  button.addEventListener('click', function(){
    form.style.display = 'block';
    side.style.opacity = '0';
    headerSection.style.opacity = '0';
    description.style.opacity = '0';
    description.style.visibility = 'hidden';

    // Add styles to the body to disable scrolling
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';
  });

}

openForm();

function closeForm() {
  var form = document.querySelector('.hulkForm');
  var side = document.querySelector('.card');
  var headerSection = document.querySelector('[data-section-id="header"]');
  var description = document.querySelector('.product-block-list__item--description');
  var body = document.body;

  form.style.display = 'none';
  side.style.opacity = '1';
  headerSection.style.opacity = '1';
  description.style.opacity = '1';
  description.style.visibility = 'visible';
  body.style.overflow = 'auto'; // Enable scrolling on the body
  body.style.position = 'static'
}

document.addEventListener('DOMContentLoaded', function() {
  var closeButton = document.querySelector('.closeForm');
  if (closeButton) {
    closeButton.addEventListener('click', closeForm);
  }
});

